import {Component, OnInit, Input, Inject} from '@angular/core';
import {DataStoreService} from "../../shared/services/api/data-store.service";
import { ActivatedRoute, Router } from "@angular/router";
import {Appointment} from "../../shared/models/appointment";
import {FormGroup, FormBuilder, Validators} from "@angular/forms";
import {NotificationsService} from "angular2-notifications";
import {MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import {NavigationService} from "../../shared/services/navigation-service";
import {Site} from "../../shared/models/site";

export enum DialogResult {
  DELETED
}

@Component({
  selector: 'app-appointment-detail',
  templateUrl: './appointment-detail.component.html',
  styleUrls: ['./appointment-detail.component.css']
})
export class AppointmentDetailComponent implements OnInit {

  constructor(private route: ActivatedRoute,
              private dataStore: DataStoreService,
              private notificationService: NotificationsService,
              private fb: FormBuilder,
              private router: Router,
              private dialogRef: MatDialogRef<AppointmentDetailComponent> = null,
              @Inject(MAT_DIALOG_DATA) private dialogData) {
  }

  @Input() appointment: Appointment;

  ngOnInit() {
    if (this.dialogRef != null) {
      this.appointment = this.dialogData["appointment"];
    } else {
      this.route.data.subscribe((data: {appointment: Appointment}) => {
        this.appointment = data.appointment;
      }, (error) => console.error(error)); // TODO proper error handling
    }
    this.router.events.subscribe((event => {
      if (this.dialogRef != null) {
        this.dialogRef.close();
      }
    }))
  }

  navigateTo(site: Site) {
    NavigationService.navigateTo(site);
  }

  deleteAppointment(appointment: Appointment) {
    this.dataStore.deleteRecord(Appointment, appointment.id).subscribe(() => {
      this.notificationService.info("Termin gelöscht", "Der Termin wurde gelöscht");
      this.dialogRef.close(DialogResult.DELETED)
    })
  }

}



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/appointment/appointment-detail/appointment-detail.component.ts